import React from "react";
import companyLogo from "../../assets/metalabLogo.jpg";
import avatarLogo from "../../assets/avatar.png";
import Carousel from "./Carousel";
import { HashLink as Link } from 'react-router-hash-link';
import s1 from '../../assets/contribution1/c1s1.jpg'
import s2 from '../../assets/contribution1/c1s2.png'
import s3 from '../../assets/contribution1/c1s3.png'
import s4 from '../../assets/contribution1/c1s4.png'
import s5 from '../../assets/contribution1/c1s5.png'
import s6 from '../../assets/contribution1/c1s6.png'
import s7 from '../../assets/contribution1/c1s7.png'
import s8 from '../../assets/contribution1/c1s8.png'
import s9 from '../../assets/contribution1/c1s9.png'
import s10 from '../../assets/contribution1/c1s10.jpg'
import s11 from '../../assets/contribution1/c1s11.jpg'
import s12 from '../../assets/contribution1/c1s12.jpg'
import s13 from '../../assets/contribution1/c1s13.jpg'
import s14 from '../../assets/contribution1/c1s14.png'
import o1 from '../../assets/contribution1/c1o1.png'
import o2 from '../../assets/contribution1/c1o2.png'
import { c1ifrm1 } from "../../utils/Constants.js";

const Contribution1 = () => {
  const images = [s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14]; // Array of image sources for the slideshow

  const nextImage = () => {
    setImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setImageIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  return (
    <div className="p-4 mt-8">
      <div
        className=" max-w-max md:max-w-[115rem] mx-auto bg-fgPurple rounded-2xl border-4 border-black p-6"
        style={{ boxShadow: "5px -5px 0px 0px black" }}
        id="experience-section"
      >
        <div className="bg-fgPurple2 flex flex-col items-center justify-center rounded-t-2xl mb-4">
          <Carousel images={images} />
        </div>
        <div className=" h-[400px] md:h-[550px] overflow-y-scroll">
          <div className=" ml-6 flex flex-col mr-4">
            <div className="flex">
              <img
                src={companyLogo}
                alt={`Logo of company`}
                className="mr-6 h-12 w-12 md:h-[5rem] md:w-[5rem] rounded-full object-cover shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] bg-white border-2 border-black flex-shrink-0"
              />
              <div>
                <h1 className="font-clash-display-semibold text-base md:text-xl m-0 p-0 leading-5">
                  Metalabs
                </h1>
                <h2 className="font-clash-display-medium opacity-70 text-xs md:text-lg m-0 p-0 leading-5">
                  Position: Game Designer
                </h2>
              </div>
            </div>

            <div>
              <div
                className="md:max-w-[90%] mt-4 md:ml-16 mr:8 bg-white rounded-2xl border-4 border-black p-6 space-y-2"
                style={{ boxShadow: "3px -3px 0px 0px black" }}
              >
                <p className="text-xs md:text-xl lg:text-2xl font-bold  font-clash-display-semibold m-0 p-0 lg:leading-5">
                  • Creative Lead behind Web 3.0 based AA Openworld RPG Game.
                </p>
                <p className="text-xs md:text-xl lg:text-2xl font-bold  font-clash-display-semibold m-0 p-0 lg:leading-5">
                  • Authored and Co-wrote Game Story with Narrative Events.
                </p>
                <p className="text-xs md:text-xl lg:text-2xl font-bold  font-clash-display-semibold m-0 p-0 lg:leading-5">
                  • Authored and maintained Game Design Document.
                </p>
                <p className="text-xs md:text-xl lg:text-2xl font-bold  font-clash-display-semibold m-0 p-0 lg:leading-5">
                  • Directing Visual and Narrative Style of game
                </p>
                <p className="text-xs md:text-xl lg:text-2xl font-bold  font-clash-display-semibold m-0 p-0 lg:leading-5">
                  • Created Combat Encounters, Points of Interest, Game Consumables within the game world and locations.
                </p>
                <p className="text-xs md:text-xl lg:text-2xl font-bold  font-clash-display-semibold m-0 p-0 lg:leading-5">
                  • Collaborated with partners to ensure coherent and cohesive player experience for Technical Demo.
                </p>
              </div>
              <p className="text-right mt-4 mr-20 lg:mr-40 font-clash-display-medium text-xs md:text-lg opacity-70">
                From April 2021 to March 2022
              </p>
            </div>
          </div>
          <div className=" mt-4 ml-6 flex flex-col mr-4">
            <div className="flex">
              <img
                src={avatarLogo}
                alt={`Avatar`}
                className="mr-6 h-12 w-12 md:h-[5rem] md:w-[5rem] rounded-full object-cover shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] bg-white border-2 border-black flex-shrink-0 overflow-hidden"
              />
              <div>
                <h1 className=" font-clash-display-semibold text-sm md:text-xl m-0 p-0 leading-5">
                  Arinjay Choudhury
                </h1>
                <h2 className=" font-clash-display-medium opacity-70 text-xs md:text-lg m-0 p-0 leading-5">
                  Position: Game Designer
                </h2>
              </div>
            </div>

            <div>
              <div
                className="md:max-w-[50%] mt-4 md:ml-16 mr:8 bg-fgGreen rounded-2xl border-4 border-black p-6 space-y-2"
                style={{ boxShadow: "3px -3px 0px 0px black" }}
              >
                <p className=" ml-4 font-clash-display-semibold text-sm md:text-2xl">
                  {" "}
                  This is the Level Progression !
                </p>
                <div
                  className="bg-black rounded-2xl border-2 border-black m-auto w-fit h-[18vh] md:h-[50vh]"
                  style={{ boxShadow: "4px 4px 0px 0px black" }}
                >
                  <img src={o1} className=" w-full h-full max-w-full max-h-full rounded-2xl"></img>
                </div>
              </div>
              <div
                className="md:max-w-[50%] mt-4 md:ml-16 mr:8 bg-fgGreen rounded-2xl border-4 border-black p-6 space-y-2"
                style={{ boxShadow: "3px -3px 0px 0px black" }}
              >
                <p className=" ml-4 font-clash-display-semibold text-sm md:text-2xl">
                  {" "}
                  This is the level Block out !
                </p>
                <div
                  className="bg-black rounded-2xl border-2 border-black m-auto w-fit h-[20vh] md:h-[50vh]"
                  style={{ boxShadow: "4px 4px 0px 0px black" }}
                >
                  <img src={o2} className=" w-full h-full max-w-full max-h-full rounded-2xl"></img>
                </div>
              </div>
              <div
                className="md:max-w-[50%] mt-4 md:ml-16 mr:8 bg-fgGreen rounded-2xl border-4 border-black p-6 space-y-2"
                style={{ boxShadow: "3px -3px 0px 0px black" }}
              >
                <p className=" ml-4 font-clash-display-semibold text-sm md:text-2xl">
                  {" "}
                  This is the game architecture !
                </p>
                <div className="rounded-2xl border-2 border-black" style={{ boxShadow: "4px 4px 0px 0px black" }}>
                  <iframe
                    frameBorder="0"
                    className=" w-full h-[20vh] md:h-[50vh] rounded-2xl"
                    src={c1ifrm1}
                  ></iframe>
                </div>
              </div>
              <div
                className="md:max-w-[50%] mt-4 md:ml-16 mr:8 bg-fgGreen rounded-2xl border-4 border-black p-6 space-y-2"
                style={{ boxShadow: "3px -3px 0px 0px black" }}
              >
                <p className=" ml-4 font-clash-display-semibold text-sm md:text-2xl">
                  {" "}
                  The Game Deisgn Document !
                </p>
                <div className="rounded-2xl border-2 border-black" style={{ boxShadow: "4px 4px 0px 0px black" }}>
                  <iframe
                    frameBorder="0"
                    className=" w-full h-[30vh] md:h-[50vh] rounded-2xl"
                    src="https://drive.google.com/file/d/1e7X7635hQBuWeu206dBwuw6XPGDcobNh/preview"
                  ></iframe>
                </div>
              </div>
              <div
                className="md:max-w-[50%] mt-4 md:ml-16 mr:8 bg-fgGreen rounded-2xl border-4 border-black p-6 space-y-2"
                style={{ boxShadow: "3px -3px 0px 0px black" }}
              >
                <p className=" ml-4 font-clash-display-semibold text-sm md:text-2xl">
                  {" "}
                  XP and Economy !
                </p>
                <div className="rounded-2xl border-2 border-black" style={{ boxShadow: "4px 4px 0px 0px black" }}>
                  <iframe
                    frameBorder="0"
                    className=" w-full h-[30vh] md:h-[50vh] rounded-2xl"
                    src="https://drive.google.com/file/d/1DIGjzYu7Mn6modL6JZ6IG2igoG68mXB1/preview"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Comment section and MyContributions Box */}
        <div className="flex justify-normal gap-5 p-2 mt-8">
          <div className={`bg-fgPurple2 rounded-2xl py-4 px-12 w-[100vw]`}>
            <h2
              className={`text-white text-xl md:text-xl font-clash-display-semibold`}
            ></h2>
          </div>
          <Link smooth to="/#my-works-section">
            <div
              className="inline-block bg-fgYellow rounded-2xl shadow-md border-2 md:border-4 border-black p-2 md:py-4 md:px-12"
              style={{ boxShadow: "-3px 3px 0px 0px black" }}
            >

              <h2 className=" md:whitespace-nowrap text-xs md:text-3xl text-center font-clash-display-semibold">
                My Contribution
              </h2>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Contribution1;
